import { variants } from '@/components/Link/Link.styles';
import tw, { styled } from 'twin.macro';

export type LoginLinkSize = 'small' | 'large';

export const Button = styled('button', {
  shouldForwardProp: (propName) => propName !== 'size',
})<{
  size: LoginLinkSize;
}>`
  ${({ size }) => {
    switch (size) {
      case 'small':
        return variants.platform_login_small;
      case 'large':
        return variants.platform_login;
    }
  }}
`;

export const IconWrapper = styled('span', {
  shouldForwardProp: (propName) => propName !== 'size',
})<{
  size: LoginLinkSize;
}>`
  ${tw`inline-block`}
  ${({ size }) => {
    switch (size) {
      case 'small':
        return tw`mr-1 h-[16px] w-[16px]`;
      case 'large':
        return tw`mr-2 h-[36px] w-[36px]`;
    }
  }}
`;
